"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_FLAGGED_OBJECT = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.GET_FLAGGED_OBJECT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetFlaggedObject($input: FlaggableObjectInput!) {\n    flaggableObject(input: $input) {\n      ...FlaggableObject\n    }\n  }\n  ", "\n"], ["\n  query GetFlaggedObject($input: FlaggableObjectInput!) {\n    flaggableObject(input: $input) {\n      ...FlaggableObject\n    }\n  }\n  ", "\n"])), fragments_1.FLAGGABLE_OBJECT_FRAGMENT);
var templateObject_1;
